<p>shopify-connection works!</p>
